import { useChartState } from "@features/sales-v3/hooks/use-chart-state";
import { type SalesPageMetric } from "@north-beam/nb-client-side";

import { CompareMenus } from "./compare-menus";
import { MainMetricSelect } from "./main-metric-select";

interface MetricsControlProps {
  metrics: SalesPageMetric[];
  chartIndex: number;
  disabled?: boolean;
}

export const MetricsControl = ({
  metrics,
  chartIndex,
  disabled,
}: MetricsControlProps) => {
  const { chartConfigs } = useChartState();
  const chartConfig = chartConfigs[chartIndex];
  const { mainMetric, comparisons, chartType } = chartConfig;

  return (
    <div className="flex space-x-3 items-start">
      <MainMetricSelect
        chartIndex={chartIndex}
        metrics={metrics}
        mainMetric={mainMetric}
        isBarChart={chartType === "bar"}
        disabled={disabled}
      />
      <CompareMenus
        metrics={metrics}
        comparisons={comparisons}
        chartIndex={chartIndex}
        isBarChart={chartType === "bar"}
        disabled={disabled}
      />
    </div>
  );
};
